import script from "./ChatUserOrders.vue?vue&type=script&setup=true&lang=jsx"
export * from "./ChatUserOrders.vue?vue&type=script&setup=true&lang=jsx"

import "./ChatUserOrders.vue?vue&type=style&index=0&id=13593990&lang=scss"

const __exports__ = script;

export default __exports__